import { MAX_PINNED_CHATS } from '@/components/home/org-thread-list-constants';

/**
 * First-page sizes of the workspace sidebar lists. Shared by the client hooks
 * and the server snapshot so both request identical pages.
 */
export const ROOT_THREADS_PAGE_SIZE = 6;
export const SIDEBAR_THREADS_PAGE_SIZE = 100;

/**
 * First page of the root chat list. Pinned chats come back in it but render
 * under Pinned, so the page carries room for every pin and Recent still fills
 * a full page on first paint (no skeleton that real rows then push down).
 */
export const ROOT_THREADS_FIRST_PAGE_SIZE =
  ROOT_THREADS_PAGE_SIZE + MAX_PINNED_CHATS;
